import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtExtrasPrivacySection from "../components/extras/NtExtrasPrivacySection";
import NtExtrasPrivacyInfoSection from "../components/extras/NtExtrasPrivacyInfoSection";

class PrivacyController extends React.Component {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer style={styles.container}>
        <NtExtrasPrivacySection />
        <NtExtrasPrivacyInfoSection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default PrivacyController;
